import { useModalAlert } from '../components/ModalAlert';
import { generateAgentSlug, shortUuid, toSlug, SLUG_RE } from '../utils/agentNames';

// ─── Legacy simple-create (no wizard) ────────────────────────────────────────
// Kept for programmatic use or fallback only.
export async function createAgentDirect(config, authToken, onCreated) {
  const slug = generateAgentSlug();
  const suffix = shortUuid();
  const name = `${slug}-${suffix}`;
  const res = await fetch(`${config.apiBaseUrl}/agents`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${authToken}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, max_history_messages: 10 }),
  });
  if (!res.ok) throw new Error(`Create failed (${res.status})`);
  const agent = await res.json();
  onCreated?.(agent);
  return agent;
}

/**
 * CreateAgentForm — replaced by the Agent Onboard Wizard.
 * Renders a single "+ New Agent" button that opens the wizard via onRequestOnboard.
 *
 * Props:
 *   config, authToken — kept for compat; not used directly (wizard handles calls)
 *   onCreated         — callback forwarded from wizard's onCompleted
 *   onRequestOnboard  — (portfolio: null) → opens the wizard at the portfolio-picker step
 */
const CreateAgentForm = ({ config, authToken, onCreated, onRequestOnboard }) => {
  return (
    <button
      onClick={() => onRequestOnboard?.(null)}
      className="flex items-center gap-1 px-3 py-1.5 bg-cyan-700 hover:bg-cyan-600 text-white text-sm rounded transition-colors"
    >
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
      </svg>
      New Agent
    </button>
  );
};

export default CreateAgentForm;
